import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { TextField } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { selectCurrentDevice } from "../../../store/deviceStore/deviceSelectors";
import { selectCurrentConfiguration } from "../../../store/deviceConfigurationStore/deviceConfigurationSelectors";
import HorizontalPanel from "../../../components/HorizontalPanel";
import { Toolbar } from "../../../app/components";
import { useTypedDispatch } from "../../../app/state";
import { setEditMode } from "../../../store/generalStore/generalState";
import { DeviceTypeEnum } from "../../../models/enums/DeviceType.enum";
import { setDrawingStatus } from "../../../store/drawingStore/drawingState";
import StationaryPoint from "../../../containers/DeviceMap/MapPoint/StationaryPoint";
import PortablePoint from "../../../containers/DeviceMap/MapPoint/PortablePoint";
import { selectLocationById, selectLocationByMapId } from "../../../store/locationStore/locationSelectors";
import { selectBuildingById } from "../../../store/buildingStore/buildingsSelectors";
import { selectFloorByMapId } from "../../../store/floorStore/floorSelectors";

import classes from './index.module.scss';

export const DevicePosition = (props) => {
  const dispatch = useTypedDispatch();
  const { formDisabled, positionButtonEnabled = true } = props;
  const selectedDevice = useSelector(selectCurrentDevice);
  const selectedConfiguration = useSelector(selectCurrentConfiguration);
  const currentConfiguration = selectedConfiguration || selectedDevice?.configuration;
  const isDeviceStationary = currentConfiguration?.type === DeviceTypeEnum.STATIONARY;
  const locationByMap = useSelector(selectLocationByMapId(selectedDevice?.mapId));
  const floor = useSelector(selectFloorByMapId(selectedDevice?.mapId))
  const building = useSelector(selectBuildingById(floor?.buildingId));
  const locationByFloor = useSelector(selectLocationById(building?.locationId));
  const location = locationByMap || locationByFloor;

  const latitude = currentConfiguration?.mapPoint?.geoPoint?.latitude;
  const longitude = currentConfiguration?.mapPoint?.geoPoint?.longitude;
  const geoPointExists = !!latitude && !!longitude;

  useEffect(() => {
    dispatch(setEditMode(false));
    dispatch(setDrawingStatus(false));
  }, []);

  return (
    <HorizontalPanel size={HorizontalPanel.SIZES.WHOLE_SPACE}>
      <HorizontalPanel size={HorizontalPanel.SIZES.SMALL}>
        <Toolbar title='Device Position' />
      </HorizontalPanel>
      <HorizontalPanel
        size={HorizontalPanel.SIZES.REST_SPACE}
        className={classes.container}
      >
        <Grid container spacing={2} className={classes.coordinatesBlock}>
          <Grid item xs={12}>
            <TextField
              label='Location'
              required
              variant='outlined'
              name='location'
              fullWidth
              disabled
              value={location?.name || ''}
            />
          </Grid>
          {
            building ? (
              <Grid item xs={12}>
                <TextField
                  label='Building'
                  required
                  variant='outlined'
                  name='building'
                  fullWidth
                  disabled
                  value={building?.name || ''}
                />
              </Grid>
            ) : null
          }
          {
            floor ? (
              <Grid item xs={12}>
                <TextField
                  label='Floor'
                  required
                  variant='outlined'
                  name='floor'
                  fullWidth
                  disabled
                  value={floor?.name || ''}
                />
              </Grid>
            ) : null
          }
          {
            geoPointExists && isDeviceStationary ? (
              <>
                <Grid item xs={12}>
                  <TextField
                    label='Latitude'
                    variant='outlined'
                    name='latitude'
                    fullWidth
                    disabled
                    value={latitude}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label='Longitude'
                    variant='outlined'
                    name='longitude'
                    fullWidth
                    disabled
                    value={longitude}
                  />
                </Grid>
              </>
            ) : null
          }
        </Grid>
        {
          positionButtonEnabled ? (
            <>
              {
                isDeviceStationary ? (
                  <StationaryPoint formDisabled={formDisabled} />
                ) : (
                  <PortablePoint formDisabled={formDisabled} />
                )
              }
            </>
          ) : null
        }
      </HorizontalPanel>
    </HorizontalPanel>
  );
}
